// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.AccountInfo input{

    min-width: 150px
    
}
.text-warning {
    width: 99px;
    font-size: 50px;
    height: 99px;
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;}

.SpinnerPage {
    gap: 2%;
    width: 100%;
    position: absolute;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;}

.BodySpinner{
    display: flex;
    justify-content: center;
    align-items: center;
}
.CardSpinner{
    width: 50%;
    height: 30%;
    display: flex;
    justify-content: center;
    
}
.AccountCard{
    /* display: unset; */
    /* width: 60%; */
    border: 1px solid;
    border-color: grey;
    border-radius: 30px;
    background-color: transparent;
}
.ContainerAccount{
    width: 100%;
    background-color: white;
    padding: 1%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;

    
}

.ContainerAccount .col{
    padding: 1%;
    

}

.ChangePSW{
    justify-content: center;
    display: flex;
    flex-direction: column;
    padding: 5%;
    min-width: 300px;
    max-width: 400px;
}

.form-control:disabled{
    background-color: white !important;
}
.form-floating>.form-control:disabled~label::after, .form-floating>:disabled~label::after {
background-color: transparent !important;
}


/* .SwitchBtn{
    display: flex;
    flex-direction: column;
    gap: 20%;
    height: 100%;
    padding: 10%;
    border-right: 1px solid grey;
} */

.form-floating>label{    z-index: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Account/Account.css"],"names":[],"mappings":";;;AAGA;;IAEI;;AAEJ;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,qEAAqE,CAAC;;AAE1E;IACI,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB,CAAC;;AAExB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;;AAE3B;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;;;AAGvB;;AAEA;IACI,WAAW;;;AAGf;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;AACA;AACA,wCAAwC;AACxC;;;AAGA;;;;;;;GAOG;;AAEH,yBAAyB,qBAAqB;AAC9C","sourcesContent":["\n\n\n.AccountInfo input{\n\n    min-width: 150px\n    \n}\n.text-warning {\n    width: 99px;\n    font-size: 50px;\n    height: 99px;\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;}\n\n.SpinnerPage {\n    gap: 2%;\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;}\n\n.BodySpinner{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.CardSpinner{\n    width: 50%;\n    height: 30%;\n    display: flex;\n    justify-content: center;\n    \n}\n.AccountCard{\n    /* display: unset; */\n    /* width: 60%; */\n    border: 1px solid;\n    border-color: grey;\n    border-radius: 30px;\n    background-color: transparent;\n}\n.ContainerAccount{\n    width: 100%;\n    background-color: white;\n    padding: 1%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 30px;\n\n    \n}\n\n.ContainerAccount .col{\n    padding: 1%;\n    \n\n}\n\n.ChangePSW{\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    padding: 5%;\n    min-width: 300px;\n    max-width: 400px;\n}\n\n.form-control:disabled{\n    background-color: white !important;\n}\n.form-floating>.form-control:disabled~label::after, .form-floating>:disabled~label::after {\nbackground-color: transparent !important;\n}\n\n\n/* .SwitchBtn{\n    display: flex;\n    flex-direction: column;\n    gap: 20%;\n    height: 100%;\n    padding: 10%;\n    border-right: 1px solid grey;\n} */\n\n.form-floating>label{    z-index: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
